import React from 'react'
import { AdminPageWrapper, PageHeader, TCancelButton, UnitGroupData } from 'components'
import { useHistory, useLocation } from 'react-router-dom'

const CreateEditUnitGroup = () => {
  const location = useLocation()
  const history = useHistory()

  const {
    state: {
      _id
    }
  } = location

  const RightContent = () => (
    <TCancelButton
      onClick={() => history.goBack()}
    >
      Back
    </TCancelButton>
  )

  return (
    <>
      <PageHeader
        title={`${_id ? 'Editing' : 'Creating new'} unit group`}
        rightContent={<RightContent />}
      />
      <AdminPageWrapper>
        <UnitGroupData
          _id={_id}
        />
      </AdminPageWrapper>
    </>
  )
}

export default CreateEditUnitGroup
